import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  /** Seconds. Small offsets stagger siblings without delaying the first one. */
  delay?: number;
  /** Animate immediately instead of on scroll. For above-the-fold content only. */
  onMount?: boolean;
  className?: string;
}
const EASE = [0.23, 1, 0.32, 1] as const;

/**
 * A single, restrained entrance: 12px up and a fade, 260ms. Reserved for the
 * hero and the product artefacts, not for every heading on the page.
 */
export function Reveal({
  children,
  delay = 0,
  onMount = false,
  className
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className} data-id="element-28" data-mp="2xqr1l1rvmguq">{children}</div>;
  }
  const from = {
    opacity: 0,
    y: 12
  };
  const to = {
    opacity: 1,
    y: 0
  };
  const transition = {
    duration: 0.26,
    ease: EASE,
    delay
  };
  if (onMount) {
    return <motion.div className={className} initial={from} animate={to} transition={transition} data-id="element-29" data-mp="cyxksccu464e">
        {children}
      </motion.div>;
  }
  return <motion.div className={className} initial={from} whileInView={to} viewport={{
    once: true,
    amount: 0.25
  }} transition={transition} data-id="element-30" data-mp="2c2bw92ob8kwr">
      {children}
    </motion.div>;
}